import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {Link, useNavigate} from "react-router-dom";
import Select from "react-select";
import customStyles, {cryptoNewCustomStyles, customStyles2, customStyles3, newCustomStyles} from "../../customstyle/customstyle";
import {FilterChart} from "../../components/AccountMetrics/FinancialPerformance";
import "./style.scss";

export default function Tabination({
  variant = 1,
  tab,
  className,
  tabItems,
  setActiveTab,
  activeTab,
  cs,
  style,
  tabStyle,
  balanceChart,
  radioButton = false,
  onTabChange = false,
  isChart = false,
  showTabs,
  isToolbar = false,
  resetClickEvent = () => {},
  breakpoint,
}) {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobileBreak = breakpoint ? windowWidth <= breakpoint : windowWidth <= 800;

  const [items, setItems] = useState([]);
  const [active, setActive] = useState(activeTab);
  const [none, setNone] = useState([1, 2, 3]);

  const tabsRef = React.useRef({});
  const [indicatorStyle, setIndicatorStyle] = useState({left: 0, width: 0, top: 0, height: 0, opacity: 0});

  useEffect(() => {
    const timer = setTimeout(() => {
      const activeIdx = activeTab !== undefined ? activeTab : active;
      const activeEl = tabsRef.current[activeIdx];
      if (activeEl) {
        setIndicatorStyle({
          left: activeEl.offsetLeft,
          width: activeEl.offsetWidth,
          top: activeEl.offsetTop,
          height: activeEl.offsetHeight,
          opacity: 1,
        });
      }
    }, 50);
    return () => clearTimeout(timer);
  }, [active, activeTab, items, windowWidth, isMobileBreak]);

  useEffect(() => {}, [active]);
  useEffect(() => {}, [active]);

  const [chartTimeline, setChartTimeline] = useState("1M");
  const navigate = useNavigate();
  function handleTabMobile(e, idx) {
    if (setActiveTab) {
      setActiveTab(Number(idx));
    }
    // navigate(e);
    setActive(Number(idx));
    resetClickEvent(false);
    setNone(none);
    if (tab === true) {
      localStorage.setItem("activeTab", JSON.stringify(tabItems[idx]));
    }
  }
  function handleTab(e, idx) {
    if (setActiveTab) {
      setActiveTab(Number(idx));
    }
    navigate(e);
    setActive(Number(idx));
    resetClickEvent(false);
    setNone(none);
    if (tab === true) {
      localStorage.setItem("activeTab", JSON.stringify(tabItems[idx]));
    }
  }

  useEffect(() => {
    const handleTabChange = (activeTab) => {
      setActive(activeTab);
      resetClickEvent(false);
    };
    handleTabChange(activeTab);
  }, [onTabChange]);

  useEffect(() => {
    setItems(tabItems);
  }, [tabItems]);
  const support = useSelector((state) => state.support);

  const options = items.map((item, index) => ({
    label: item?.name,
    value: [item?.path, index].join(","),
  }));

  const [isLoading, setIsLoading] = useState(support.isLoading);
  const selectedBrand = useSelector((state) => state.brand.selectedBrand);

  if (isLoading === true) {
    return <div style={{position: "absolute", width: "100%", height: "100%"}}>{/* <LoaderOverlay /> */}</div>;
  } else {
    return (
      <>
        {variant === 2 && (
          <div className="tabination-container_variant2">
            <div
              style={style}
              className="tabination-subcontainer"
            >
              <div>
                <ul className="tabination-container_toggle">
                  {items.map((item, index) => {
                    return (
                      <li
                        style={tabStyle}
                        key={index}
                        onClick={(e) => handleTabMobile(e, index)}
                        className={index === active ? "tabination-toggle" : ""}
                      >
                        {item["name"]}
                      </li>
                    );
                  })}
                </ul>
                {isChart ? <ul className="tabination-container_chart_toggle"></ul> : <></>}
              </div>
              {isToolbar ? <div className="tabination-container_toolbar"></div> : <></>}
            </div>
            <div className="tabination_wrapper">{items[active]?.content}</div>
          </div>
        )}

        {variant === 3 && (
          <div className="tabination-container variant_3">
            {/* <div className="tabination_subcontainer_wrapper ">
              <ul
                style={style}
                className="tabination-subcontainer tabination_normal"
              >
                {items?.map((item, index) => {
                  return (
                    <li
                      style={tabStyle}
                      key={index}
                      onClick={(e) => handleTab(e, index)}
                    >
                      <Link to={item?.path}>
                        <span className={index === active ? "tabination-toggle" : ""}>{item && item["name"]}</span>
                      </Link>
                    </li>
                  );
                })}
              </ul>
              <div style={{padding: "0"}}>
                {" "}
                {showTabs === false ? (
                  ""
                ) : (
                  <Select
                    name="tabs"
                    id="tabs"
                    className="tabination_mobile"
                    classNamePrefix="react-select"
                    options={options}
                    isSearchable={false}
                    styles={newCustomStyles}
                    value={options[activeTab]}
                    onChange={(selectedOption) => {
                      const [path, index] = selectedOption.value.split(",");
                      handleTab(path, index);
                    }}
                  />
                )}
              </div>
            </div> */}
            <div className="tabination_wrapper">{items[active]?.content}</div>
          </div>
        )}

        {variant === 4 ? (
          <div className="tabination-container variant_4">
            <ul
              style={style}
              className={className === "account-tabination" ? "account-tabination tabination-subcontainer" : "tabination-subcontainer tabination_normal_5"}
            >
              {items.map((item, index) => {
                return (
                  <li
                    style={tabStyle}
                    key={index}
                    onClick={(e) => handleTabMobile(e, index)}
                    className={index === active ? "active" : ""}
                  >
                    {radioButton ? (
                      <>
                        <input
                          type="radio"
                          id={`tab${index}`}
                          checked={index === active}
                          onChange={() => {}}
                        />
                        <label htmlFor={`tab${index}`}>{item["name"]}</label>
                      </>
                    ) : (
                      item["name"]
                    )}
                  </li>
                );
              })}
            </ul>
            <div className="tabination_wrapper">{items[active]?.content}</div>
          </div>
        ) : (
          ""
        )}
        {/* Updated Variant 5 with Variant 7 Logic */}
        {variant === 5 && (
          <div className="tabination-container variant_5">
            <div className="tabination_subcontainer_wrapper">
              {/* 1. DESKTOP VIEW */}
              {!isMobileBreak && (
                <div className="ver5Wrapper">
                  <div className="Chart_tabination">
                    <ul
                      style={{...style, position: "relative", zIndex: 1}}
                      className="tabination-subcontainer tabination_normal_5 custom-dynamic-tabs"
                    >
                      <div
                        className="sliding-indicator"
                        style={indicatorStyle}
                      />
                      {items?.map((item, index) => (
                        <li
                          style={{...tabStyle, zIndex: 2}}
                          key={index}
                          onClick={(e) => handleTabMobile(e, index)}
                        >
                          <Link to={item?.path}>
                            <span
                              ref={(el) => (tabsRef.current[index] = el)}
                              className={index === activeTab ? "tabination-toggle" : ""}
                            >
                              {item.name}
                            </span>
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}

              {/* 2. MOBILE VIEW */}
              {isMobileBreak && (
                <Select
                  name="tabs"
                  id="tabs"
                  className="tabination_mobile custom-dynamic-select"
                  isSearchable={false}
                  classNamePrefix="react-select"
                  options={options}
                  styles={selectedBrand?.brand === "equity_edge" ? newCustomStyles(49) : selectedBrand?.brand === "crypto_edge" ? cryptoNewCustomStyles(49) : newCustomStyles(49)}
                  value={options[activeTab]}
                  onChange={(selectedOption) => {
                    const [path, index] = selectedOption.value.split(",");
                    handleTab(path, index);
                  }}
                />
              )}

              {/* 3. SHARED TOOLBAR (The Fix) */}
              {/* This renders on BOTH mobile and desktop whenever the Balance tab (index 0) is active */}
              <div
                className="toolbar-wrapper"
              >
                {balanceChart && Number(active) === 0 && <FilterChart />}
              </div>
            </div>

            <div className="tabination_wrapper">{items[active]?.content}</div>
          </div>
        )}
        {variant === 6 && (
          <div className="tabination-container variant_6 dashboardFilter">
            <div className="tabination_subcontainer_wrapper">
              <Select
                name="tabs"
                id="tabs"
                className="tabination_var6"
                classNamePrefix="react-select"
                isSearchable={false}
                options={options}
                styles={selectedBrand?.brand === "equity_edge" ? newCustomStyles(40) : selectedBrand?.brand === "crypto_edge" ? cryptoNewCustomStyles(40) : newCustomStyles(40)}
                value={options[activeTab]}
                onChange={(selectedOption) => {
                  const [path, index] = selectedOption.value.split(",");
                  handleTab(path, index);
                }}
              />
            </div>
            <div className="tabination_wrapper">{items[active]?.content}</div>
          </div>
        )}
        {variant === 7 && (
          <div className="tabination-container variant_7">
            <div className="tabination_subcontainer_wrapper">
              {!isMobileBreak && (
                <ul
                  style={{...style, position: "relative", zIndex: 1}}
                  className="tabination-subcontainer tabination_normal_7 custom-dynamic-tabs"
                >
                  <div
                    className="sliding-indicator"
                    style={indicatorStyle}
                  />
                  {items?.map((item, index) => (
                    <li
                      style={{...tabStyle, zIndex: 2}}
                      key={index}
                      onClick={(e) => handleTabMobile(e, index)}
                    >
                      <Link to={item?.path}>
                        <span
                          ref={(el) => (tabsRef.current[index] = el)}
                          className={index === activeTab ? "tabination-toggle" : ""}
                        >
                          {item.name}
                        </span>
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
              {isMobileBreak && (
                <Select
                  name="tabs"
                  id="tabs"
                  className="tabination_mobile custom-dynamic-select"
                  isSearchable={false}
                  classNamePrefix="react-select"
                  options={options}
                  styles={selectedBrand?.brand === "equity_edge" ? newCustomStyles(40) : selectedBrand?.brand === "crypto_edge" ? cryptoNewCustomStyles(40) : newCustomStyles(40)}
                  value={options[activeTab]}
                  onChange={(selectedOption) => {
                    const [path, index] = selectedOption.value.split(",");
                    handleTab(path, index);
                  }}
                />
              )}
            </div>
            <div className="tabination_wrapper">{items[active]?.content}</div>
          </div>
        )}
        {variant === 8 && (
          <div className="tabination-container variant_7">
            <div className="tabination_subcontainer_wrapper">
              <ul
                style={{...style, position: "relative", zIndex: 1}}
                className="tabination-subcontainer tabination_normal_7"
              >
                <div
                  className="sliding-indicator"
                  style={indicatorStyle}
                />
                {items?.map((item, index) => (
                  <li
                    style={{...tabStyle, zIndex: 2}}
                    key={index}
                    onClick={(e) => handleTabMobile(e, index)}
                  >
                    <a style={{cursor: "pointer"}}>
                      <span
                        ref={(el) => (tabsRef.current[index] = el)}
                        className={index === activeTab ? "tabination-toggle" : ""}
                      >
                        {item.name}
                      </span>
                    </a>
                  </li>
                ))}
              </ul>
              <Select
                name="tabs"
                id="tabs"
                className="tabination_mobile"
                isSearchable={false}
                classNamePrefix="react-select"
                options={options}
                styles={selectedBrand?.brand === "equity_edge" ? newCustomStyles(40) : selectedBrand?.brand === "crypto_edge" ? cryptoNewCustomStyles(40) : newCustomStyles(40)}
                value={options[activeTab]}
                onChange={(selectedOption) => {
                  const [path, index] = selectedOption.value.split(",");
                  handleTabMobile(null, index);
                }}
              />
            </div>
            <div className="tabination_wrapper">{items[active]?.content}</div>
          </div>
        )}
      </>
    );
  }
}
